(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class ViewAllProducts extends HTMLElement {
    connectedCallback() {
      if (this.button) {
        return;
      }

      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-view-all-label]');

      this.button?.addEventListener('click', this.loadAllProducts.bind(this));
    }

    async loadAllProducts() {
      if (this.loading || !this.button) {
        return;
      }

      const sectionId = this.dataset.sectionId;
      const productList = document.getElementById(`product-list-${sectionId}`);

      if (!sectionId || !productList) {
        return;
      }

      this.loading = true;
      this.button.disabled = true;
      this.setLabel(this.dataset.loadingText);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        const pageParam = this.dataset.pageParam || 'page';
        const baseUrl = new URL(window.location.href);
        const currentPage = Number.parseInt(baseUrl.searchParams.get(pageParam) || this.dataset.currentPage || '1', 10);
        const pages = Number.parseInt(this.dataset.pages || '1', 10);
        const pageMarkup = new Map([[currentPage, productList.innerHTML]]);

        baseUrl.searchParams.delete('section_id');

        const loadPage = async (page) => {
          const pageUrl = new URL(baseUrl);
          pageUrl.searchParams.set(pageParam, String(page));
          pageUrl.searchParams.set('section_id', sectionId);

          const response = await fetch(pageUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) {
            throw new Error(`Unable to load page ${page}`);
          }

          const sectionHtml = await response.text();
          const sectionDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const nextProductList = sectionDocument.getElementById(`product-list-${sectionId}`);

          if (!nextProductList) {
            throw new Error(`Unable to find products for page ${page}`);
          }

          return [page, nextProductList.innerHTML];
        };

        const pageNumbers = Array.from({ length: pages }, (_, index) => index + 1).filter((page) => page !== currentPage);

        for (let index = 0; index < pageNumbers.length; index += 4) {
          const pageResults = await Promise.all(pageNumbers.slice(index, index + 4).map(loadPage));

          for (const [page, markup] of pageResults) {
            pageMarkup.set(page, markup);
          }
        }

        productList.innerHTML = Array.from(pageMarkup.keys()).sort((a, b) => a - b).map((page) => pageMarkup.get(page)).join('');
        productList.closest('.collection__main')?.querySelector('.pagination')?.setAttribute('hidden', '');
        this.setLabel(this.dataset.completeText);
      } catch (error) {
        this.button.disabled = false;
        this.setLabel(this.dataset.errorText);
      } finally {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        this.loading = false;
      }
    }

    setLabel(text) {
      if (this.label && text) {
        this.label.textContent = text;
      }
    }
  }

  if (!window.customElements.get('view-all-products')) {
    window.customElements.define('view-all-products', ViewAllProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorelli-area-astor-jess-page"] && !Shopify.designMode) return;
  try {
    
  const areaMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncAreaVideos = () => {
    document.querySelectorAll('.vorelli-area-astor-jess-shell video').forEach((video) => {
      if (areaMotionPreference.matches) {
        video.pause();
      } else if (video.hasAttribute('autoplay')) {
        video.play().catch(() => {});
      }
    });
  };

  const startAreaHeroVideos = () => {
    if (areaMotionPreference.matches) return;
    document.querySelectorAll('.vorelli-area-astor-jess-shell video[data-area-hero-video]').forEach((video) => {
      video.play().catch(() => {});
    });
  };

  const deferredAreaVideoObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && !areaMotionPreference.matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '160px 0px', threshold: 0.05 })
    : null;

  document.querySelectorAll('.vorelli-area-astor-jess-shell video[data-area-deferred-video]').forEach((video) => {
    deferredAreaVideoObserver?.observe(video);
  });

  syncAreaVideos();
  document.querySelectorAll('.vorelli-area-astor-jess-shell .elite-area__film-frame').forEach((frame) => {
    frame.addEventListener('pointerenter', startAreaHeroVideos, { once: true, passive: true });
    frame.addEventListener('focusin', startAreaHeroVideos, { once: true });
  });
  window.addEventListener('scroll', startAreaHeroVideos, { once: true, passive: true });
  window.addEventListener('touchstart', startAreaHeroVideos, { once: true, passive: true });
  areaMotionPreference.addEventListener('change', () => {
    syncAreaVideos();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorelli-nature-video"] && !Shopify.designMode) return;
  try {
    
  let naturePlayerPromise;

  function initialiseNatureFilms(root) {
    root.querySelectorAll('[data-vorelli-nature-video]').forEach((container) => {
      if (container.dataset.initialised) return;
      container.dataset.initialised = 'true';
      const video = container.querySelector('video');
      const button = container.querySelector('button');
      const overlay = container.querySelector('[data-nature-play-overlay]');
      let player;

      video.addEventListener('playing', () => {
        overlay.hidden = true;
      });

      const startPlayback = async () => {
        button.disabled = true;
        try {
          if (video.canPlayType('application/vnd.apple.mpegurl') && !window.MediaSource) {
            if (!video.src) video.src = container.dataset.playlist;
            await video.play();
          } else {
            if (!naturePlayerPromise) {
              naturePlayerPromise = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = container.dataset.player;
                script.onload = resolve;
                script.onerror = () => {
                  naturePlayerPromise = undefined;
                  reject(new Error('Video player could not load'));
                };
                document.head.appendChild(script);
              });
            }
            await naturePlayerPromise;
            if (!window.Hls || !window.Hls.isSupported()) throw new Error('Streaming playback unavailable');
            if (!player) {
              player = new window.Hls({ maxBufferLength: 15, maxMaxBufferLength: 30 });
              player.on(window.Hls.Events.MEDIA_ATTACHED, () => {
                player.loadSource(container.dataset.playlist);
              });
              player.on(window.Hls.Events.MANIFEST_PARSED, () => {
                video.play().catch(() => { button.disabled = false; });
              });
              player.on(window.Hls.Events.ERROR, (_event, data) => {
                if (data.fatal) {
                  player.destroy();
                  player = undefined;
                  overlay.hidden = false;
                  button.disabled = false;
                }
              });
              player.attachMedia(video);
            } else {
              await video.play();
            }
          }
        } catch (_error) {
          button.disabled = false;
        }
      };
      button.addEventListener('click', startPlayback);
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) video.pause();
      });
      observer.observe(container);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
    });
  }

  initialiseNatureFilms(document);
  document.addEventListener('shopify:section:load', (event) => initialiseNatureFilms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorelli-projects-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vorelli-filter]');
    if (!button) return;

    const section = button.closest('[data-section-id]');
    const filter = button.dataset.vorelliFilter;

    section.querySelectorAll('[data-vorelli-filter]').forEach((item) => {
      item.classList.toggle('is-active', item === button);
    });

    section.querySelectorAll('[data-vorelli-room]').forEach((project) => {
      project.hidden = filter !== 'all' && project.dataset.vorelliRoom !== filter;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorelli-staircase-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rangeDash = String.fromCharCode(8211);
    var clearance = 2200;

    function numberFromField(field) {
      if (!field) {
        return 0;
      }

      var value = parseFloat(field.value);
      return Number.isFinite(value) ? value : 0;
    }

    function formatMillimetres(value) {
      return Math.max(0, Math.round(value)) + "mm";
    }

    function nearestSensibleSize(value) {
      var sizes = [700, 800, 900, 1000, 1200, 1500, 1800, 2200, 2600];
      var nearest = sizes[0];
      var distance = Math.abs(value - nearest);

      sizes.forEach(function (size) {
        var nextDistance = Math.abs(value - size);
        if (nextDistance < distance) {
          nearest = size;
          distance = nextDistance;
        }
      });

      return nearest;
    }

    function nextSensibleSize(value) {
      var sizes = [700, 800, 900, 1000, 1200, 1500, 1800, 2200, 2600];
      var next = value;

      sizes.some(function (size) {
        if (size > value) {
          next = size;
          return true;
        }

        return false;
      });

      return next;
    }

    function roundToNearest50(value) {
      return Math.round(value / 50) * 50;
    }

    function formatRange(lower, upper) {
      if (upper && upper > lower) {
        return lower + rangeDash + upper + "mm";
      }

      return lower + "mm";
    }

    function setText(root, selector, value) {
      var element = root.querySelector(selector);
      if (element) {
        element.textContent = value;
      }
    }

    function diameterRecommendation(ceiling, width, length, floors) {
      var rawDiameterCm = (width + length) * 8.5;
      var rawDiameterMm = rawDiameterCm * 10;
      var lower = Math.max(nearestSensibleSize(rawDiameterMm), 700);
      var upper = null;
      var isDoubleHeight = ceiling >= 5 && floors >= 2;
      var isLuxuryFeature = ceiling >= 4.5 || floors >= 2 || length >= 5 || width >= 2.2;

      if (width < 1.8) {
        return { lower: 700, upper: 900 };
      }

      if (floors >= 3) {
        return { lower: 1200, upper: 1800 };
      }

      if (isLuxuryFeature) {
        lower = Math.max(lower, 800);
      }

      if (isDoubleHeight) {
        lower = 900;
        upper = 1200;
      }

      if (!isDoubleHeight && length >= 5 && width >= 2) {
        upper = nextSensibleSize(lower);
      }

      if (upper === lower) {
        upper = null;
      }

      return { lower: lower, upper: upper };
    }

    function dropRecommendation(ceiling) {
      var ceilingMm = Math.round(ceiling * 1000);
      var maxDrop = Math.max(0, roundToNearest50(ceilingMm - clearance));
      var lower = 0;
      var ideal = maxDrop;

      if (ceiling < 3) {
        lower = 0;
        ideal = Math.min(maxDrop, 500);
      } else if (ceiling < 4) {
        lower = Math.max(300, roundToNearest50(maxDrop * 0.45));
        ideal = roundToNearest50(maxDrop * 0.7);
      } else if (ceiling < 5) {
        lower = Math.max(800, roundToNearest50(maxDrop * 0.58));
        ideal = roundToNearest50(maxDrop * 0.78);
      } else if (ceiling < 6) {
        lower = Math.max(2200, roundToNearest50(maxDrop * 0.75));
        ideal = roundToNearest50(maxDrop * 0.88);
      } else {
        lower = Math.max(2800, roundToNearest50(maxDrop * 0.68));
        ideal = roundToNearest50(maxDrop * 0.84);
      }

      lower = Math.min(lower, maxDrop);
      ideal = Math.min(Math.max(ideal, lower), maxDrop);

      return {
        lower: lower,
        upper: maxDrop,
        ideal: ideal,
        maxDrop: maxDrop
      };
    }

    function styleDirection(style, geometry, ceiling, floors) {
      if (style === "Bespoke") {
        return "Bespoke staircase chandelier";
      }

      if (geometry === "Curved" || geometry === "Spiral" || geometry === "Open Void") {
        return style === "Circular" ? "Circular or bespoke chandelier" : "Spiral or Long Drop Chandelier";
      }

      if (floors >= 3 || ceiling >= 6.5) {
        return "Long Drop or bespoke multi-tier chandelier";
      }

      if (style === "Linear") {
        return "Linear cascade chandelier";
      }

      return style + " chandelier";
    }

    function confidence(ceiling, width, length, floors) {
      if (ceiling >= 7 || floors >= 3 || width >= 3.5 || length >= 7) {
        return "Drawings recommended";
      }

      if (ceiling >= 5 && floors >= 2) {
        return "High";
      }

      return "Indicative";
    }

    function designNote(ceiling, geometry) {
      if (ceiling >= 7) {
        return "This is a tall void. Use the result as a starting point, then check the fixing point, access method and sightlines from each level before order.";
      }

      if (geometry === "Curved" || geometry === "Spiral" || geometry === "Open Void") {
        return "Position the chandelier through the visual centre of the staircase void, with the lowest point maintaining at least 2200mm clearance from finished floor level or circulation routes.";
      }

      return "Balance the diameter with the visible stair run and keep the lowest point clear of circulation. Drawings or photographs will help confirm the fixing position.";
    }

    function syncLeadFields(root, ceiling, projectType, summary) {
      var formSummary = root.querySelector("[data-vsc-form-summary]");
      var leadCeiling = root.querySelector("[data-vsc-lead-ceiling]");
      var leadProjectType = root.querySelector("[data-vsc-lead-project-type]");

      if (formSummary) {
        formSummary.value = summary;
      }

      if (leadCeiling && (!leadCeiling.value || leadCeiling.dataset.vscAuto === "true")) {
        leadCeiling.value = ceiling ? ceiling + "m" : "";
        leadCeiling.dataset.vscAuto = "true";
      }

      if (leadProjectType && (!leadProjectType.value || leadProjectType.dataset.vscAuto === "true")) {
        leadProjectType.value = projectType || "";
        leadProjectType.dataset.vscAuto = "true";
      }
    }

    function calculate(root) {
      var ceiling = numberFromField(root.querySelector("[data-vsc-ceiling]"));
      var width = numberFromField(root.querySelector("[data-vsc-width]"));
      var length = numberFromField(root.querySelector("[data-vsc-length]"));
      var floorsField = root.querySelector("[data-vsc-floors]");
      var floors = floorsField ? parseInt(floorsField.value, 10) : 1;
      var styleField = root.querySelector("[data-vsc-style]");
      var geometryField = root.querySelector("[data-vsc-geometry]");
      var style = styleField ? styleField.value : "Spiral";
      var projectType = "Private Residence";
      var geometry = geometryField ? geometryField.value : "Open Void";

      if (!ceiling || !width || !length) {
        return;
      }

      var diameter = diameterRecommendation(ceiling, width, length, floors);
      var drop = dropRecommendation(ceiling);
      var resultStyle = styleDirection(style, geometry, ceiling, floors);
      var resultConfidence = confidence(ceiling, width, length, floors);
      var resultNote = designNote(ceiling, geometry);
      var diameterText = formatRange(diameter.lower, diameter.upper);
      var dropText = formatRange(drop.lower, drop.upper);
      var summary = "Diameter: " + diameterText + "; Drop range: " + dropText + "; Ideal drop: " + formatMillimetres(drop.ideal) + "; Maximum drop: " + formatMillimetres(drop.maxDrop) + "; Clearance: " + clearance + "mm; Staircase shape: " + geometry + "; Style: " + resultStyle + ".";

      setText(root, "[data-vsc-result-diameter]", diameterText);
      setText(root, "[data-vsc-result-drop]", dropText);
      setText(root, "[data-vsc-result-ideal-drop]", formatMillimetres(drop.ideal));
      setText(root, "[data-vsc-result-max-drop]", formatMillimetres(drop.maxDrop));
      setText(root, "[data-vsc-result-clearance]", clearance + "mm");
      setText(root, "[data-vsc-result-confidence]", resultConfidence);
      setText(root, "[data-vsc-result-style]", resultStyle);
      setText(root, "[data-vsc-result-note]", resultNote);

      syncLeadFields(root, ceiling, projectType, summary);
    }

    function revealResults(root) {
      var analysis = root.querySelector("[data-vsc-analysis]");
      var output = root.querySelector("[data-vsc-output]");
      var placeholder = root.querySelector("[data-vsc-placeholder]");

      calculate(root);

      if (analysis) {
        analysis.hidden = true;
      }

      if (placeholder) {
        placeholder.hidden = true;
      }

      if (output) {
        output.hidden = false;
      }
    }

    function init(root) {
      var button = root.querySelector("[data-vsc-generate]");
      var details = root.querySelectorAll(".vsc-faq-list details");
      var geometryField = root.querySelector("[data-vsc-geometry]");
      var stairCards = root.querySelectorAll("[data-vsc-stair-card]");

      function syncStairCards() {
        Array.prototype.forEach.call(stairCards, function (card) {
          card.setAttribute("aria-pressed", geometryField && geometryField.value === card.getAttribute("data-vsc-stair-card") ? "true" : "false");
        });
      }

      if (button) {
        button.addEventListener("click", function () {
          revealResults(root);
        });
      }

      Array.prototype.forEach.call(root.querySelectorAll("[data-vsc-form] input, [data-vsc-form] select"), function (field) {
        field.addEventListener("change", function () {
          calculate(root);
          syncStairCards();
        });
      });

      Array.prototype.forEach.call(stairCards, function (card) {
        card.addEventListener("click", function () {
          if (geometryField) {
            geometryField.value = card.getAttribute("data-vsc-stair-card");
          }
          syncStairCards();
          calculate(root);
        });
      });

      Array.prototype.forEach.call(details, function (detail) {
        var summary = detail.querySelector("summary");

        if (!summary) {
          return;
        }

        summary.setAttribute("aria-expanded", detail.open ? "true" : "false");
        detail.addEventListener("toggle", function () {
          summary.setAttribute("aria-expanded", detail.open ? "true" : "false");
        });
      });

      syncStairCards();
      calculate(root);
    }

    function ready() {
      Array.prototype.forEach.call(document.querySelectorAll("[data-vsc-calculator]"), init);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", ready);
    } else {
      ready();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorelli-staircase-collection-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tagCollectionControls() {
      document.querySelectorAll('[aria-controls="facets-drawer"]').forEach(function (button) {
        button.setAttribute('data-ga4-event', 'collection_filter_open');
      });

      document.querySelectorAll('collection-layout-switch button').forEach(function (button) {
        button.setAttribute('data-ga4-event', 'collection_grid_toggle');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tagCollectionControls);
    } else {
      tagCollectionControls();
    }

    document.addEventListener('shopify:section:load', tagCollectionControls);
  })();

  } catch(e) { console.error(e); }
})();
})();
